<template>
  <div>
    <AppHeader />
    <v-divider></v-divider>
    <v-layout wrap justify-center fill-height>
      <v-flex xs12 sm12 md12 lg2 hidden-md-and-down>
        <v-navigation-drawer
          class="fixedSidebar"
          v-model="sideNav"
          clipped
          overlay-color="yellow"
          width="100%"
          height="100vh"
          permanent
          color="#e6e6e6"
        >
          <v-layout wrap>
            <v-flex xs12 text-left py-2 text-uppercase align-self-center>
              <v-list dense v-for="(main, i) in menus" :key="i">
                <v-layout wrap>
                  <v-flex xs12 py-2>
                    <v-list-group
                      no-action
                      :value="false"
                      active-class="activated"
                    >
                      <template v-slot:activator>
                        <v-list-item-title
                          style="
                            font-size: 13px;
                            letter-spacing: 2px;
                            color: black;
                            cursor: pointer;
                            font-family: poppinssemibold;
                          "
                          >{{ main.name }}</v-list-item-title
                        >
                      </template>
                      <v-flex xs12 py-2 px-4>
                        <div style="border-bottom: 1px dotted black"></div>
                      </v-flex>
                      <template v-for="(sub, i) in main.subMenu">
                        <v-flex xs12 text-left pl-4 :key="i">
                          <v-layout wrap justify-center>
                            <v-flex xs12>
                              <router-link :to="sub.route">
                                <span
                                  :style="
                                    $route.path == sub.route
                                      ? {
                                          'font-family': 'poppinsbold',
                                          'font-size': ' 16px',
                                        }
                                      : {
                                          'font-family': 'poppinssemibold',
                                          'font-size': ' 13px',
                                        }
                                  "
                                  style="
                                    color: #737373;
                                    letter-spacing: 3px;
                                    cursor: pointer;
                                  "
                                >
                                  {{ sub.name }}
                                </span>
                              </router-link>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 py-2 px-4 :key="sub._d">
                          <div style="border-bottom: 1px solid black"></div>
                        </v-flex>
                      </template>
                    </v-list-group>
                    <!-- <v-list-group v-else> -->
                 
                  </v-flex>
                </v-layout>
                <!-- </v-list-group> -->
              </v-list>
            </v-flex>
          </v-layout>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 sm12 md12 lg10 pt-12 pt-lg-0>
        <v-layout
          wrap
          justify-center
          :style="
            $route.name == 'Dashboard'
              ? 'background-color: #FFFFFF'
              : 'background-color: #fff9c4'
          "
        >
          <v-flex xs12 pa-0>
            <v-card
              min-height="100vh"
              :color="$route.name == 'Dashboard' ? 'transparent' : '#FFFFFF'"
              :flat="$route.name == 'Dashboard' ? true : false"
            >
              <v-layout wrap justify-center>
                <v-flex xs12 pa-4>
                  <router-view :key="$route.fullPath"></router-view>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import AppHeader from "./Header.vue";
export default {
  components: {
    AppHeader,
  },
  data() {
    return {
      sideNav: true,
      admin: [{ name: "ADMINS", route: "/Admins" }],
      menus: [
         {
          name: "Dashboard",
          subMenu: [
            {
              name: "dashboard",
              route: "dashboard",
            },
          ],
        },
        {
          name: "User List",
          subMenu: [
            {
              name: "Customer List",
              route: "/users/user",
            },
            {
              name: "Seller List",
              route: "/sellers/seller",
            },
          ],
        },
        // {
        //   name: "Category",
        //   subMenu: [
        //     {
        //       name: "Category",
        //       route: "/ProductType",
        //     },
        //   ],
        // },
        // {
        //   name: "Products",
        //   subMenu: [
        //     {
        //       name: "Products",
        //       route: "/Food",
        //     },
        //   ],
        // },
        // {
        //   name: "Orders",
        //   subMenu: [
        //     {
        //       name: "Orders",
        //       route: "/OrderList",
        //     },
        //   ],
        // },
        {
          name: "Terms and conditions",
          subMenu: [
            {
              name: "Privacy policy",
              route: "/privacypolicy",
            },
             {
              name: "Cancellation policy",
              route: "/cancellationPolicy",
            },
            {
              name: "Terms and conditions",
              route: "/termsandconditions",
            },
          ],
        },
      ],
    };
  },
  // computed: {
  
  //   appMenu() {
  //     return this.menus;
  //   },
  //   navItems() {
  //     if (this.appType == "subadmin") return this.userNavItemsSubAdmin;
  //     else if (this.appType == "programadmin")
  //       return this.userNavItemsProgramAdmin;
  //     else if (this.appType == "staticcontentadmin")
  //       return this.userNavItemsStaticAdmin;
  //     else if (this.appType == "accountsadmin")
  //       return this.userNavItemsAccountsAdmin;
  //     else return this.userNavItems;
  //   },
  // },
};
</script>
<style>
@media only screen and (min-device-width: 767px) {
  .fixedSidebar {
    /* position: fixed; */

    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 50;
  }
}
@media only screen and (min-device-width: 360px) and (max-device-width: 640px) {
  .fixedSidebar {
    display: none !important;
  }
}
/* .activated { */
.activated {
  color: #0a0a09 !important;
}
/* } */
</style>